import React, { useMemo, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Spring } from 'react-spring/renderprops';
import MediaQuery from 'react-responsive';

import CompanyLogo from 'components/CompanyLogo';
import BasicButton from 'components/BasicButton';
import LinkButton from 'components/LinkButton';
import ApplyPositionForm from 'components/ApplyPositionForm';
import PanelContainer from 'components/PanelContainer';

import { StringHelpers } from 'helpers/string-helpers.js';
import { LinkBuilder } from 'helpers/link-builder';
import { linkedInShareUrl } from 'helpers/share';
import { ANIMATION_TIMEOUT_INOUT } from 'constants/animation.js';

import './styles.css';

const JobsItem = props => {
  const {
    item,
    actions: { onApply, onApplyCheck, onViewStatistics },
  } = props;

  const {
    ApplicationProcessID,
    AppDeadline,
    AppDeadlineDate,
    ProcessID,
    CompanyLogo: CompanyLogoImage = null,
    CompanyName,
    CompanyUrlAlias,
    CompanyActive,
    PositionTitle,
    StartDate,
    Descriptions,
    BlockLinkedInSharing,
  } = item;

  const [showApplyForm, setApplyForm] = useState(false);
  const [isButtonDisabled, setButtonDisabled] = useState(false);

  const applied = !!ApplicationProcessID;

  const text = useMemo(
    () =>
      StringHelpers.unescape(
        StringHelpers.trimString(Descriptions, 30, '... ')
      ),
    [Descriptions]
  );

  const showForm = () => {
    setApplyForm(true);
  };

  const hideForm = () => {
    setApplyForm(false);
  };

  const handleClickApply = () => {
    onApply(item);
    // setButtonDisabled(true);
    // onApplyCheck(item).then(success => {
    //   setButtonDisabled(false);
    //   if (success) {
    //     showForm();
    //   }
    // });
  };

  const handleOnApply = () => {
    onApply(item).then(hideForm);
  };

  const handleViewStatistics = () => {
    onViewStatistics(item);
  };

  const handleShare = () =>
    linkedInShareUrl(
      window.location.origin +
        LinkBuilder.getProcessPublicLink(item.Id, 'process')
    );

  const btnText = applied ? 'Applied' : 'Begin Application';
  const companyLink =
    CompanyActive === 'Yes' ? LinkBuilder.getFirmLink(CompanyUrlAlias) : null;

  return (
    <Spring
      from={{ opacity: 0 }}
      to={{ opacity: 1 }}
      config={{ duration: ANIMATION_TIMEOUT_INOUT }}
    >
      {props => (
        <div style={props}>
          <PanelContainer styles={{ padding: 0 }}>
            <article className="job-item">
              <div className="job-item__container">
                <div className="job-item__logo">
                  <CompanyLogo
                    name={CompanyName}
                    logo={CompanyLogoImage}
                    link={companyLink}
                    styles={{
                      width: '110px',
                      height: '110px',
                      fontSize: '0.9286rem',
                    }}
                  />

                  <MediaQuery query="(max-width: 580px)">
                    {!showApplyForm && (
                      <div className="job-item__controls">
                        <BasicButton
                          btnWidth={100}
                          btnHeight={35}
                          btnFontSize="0.8571rem"
                          btnFontWeight={600}
                          btnText={btnText}
                          btnArrow={false}
                          controlFunc={handleClickApply}
                          btnBg="#fff"
                          btnHoverBg="#f40"
                          disabled={isButtonDisabled || applied}
                        />
                        <div className="job-item__statistics">
                          <LinkButton
                            text="View Statistics"
                            btnFontSize="0.9286rem"
                            btnFontWeight="700"
                            btnFontFamily="Noto Sans"
                            controlFunc={handleViewStatistics}
                          />
                        </div>
                        {BlockLinkedInSharing === 'No' && (
                          <div className="job-item__statistics">
                            <LinkButton
                              text="Share on LinkedIn"
                              btnFontSize="0.9286rem"
                              btnFontWeight="700"
                              btnFontFamily="Noto Sans"
                              controlFunc={handleShare}
                            />
                          </div>
                        )}
                      </div>
                    )}
                  </MediaQuery>
                </div>
                <div className="job-item__content">
                  <NavLink
                    className="job-item__title"
                    to={LinkBuilder.getJobLink(ProcessID)}
                  >
                    {PositionTitle}
                  </NavLink>

                  <div className="job-item__info">
                    <div className="job-item__company">
                      {companyLink ? (
                        <LinkButton
                          text={CompanyName}
                          btnFontWeight="400"
                          btnFontFamily="Noto Sans"
                          to={companyLink}
                        />
                      ) : (
                        <span>{CompanyName}</span>
                      )}
                    </div>

                    <span className="job-item__start-date">{`Start Date: ${StartDate}`}</span>
                    {AppDeadline === 'Yes' && (
                      <span className="job-item__app-deadline">
                        Application deadline: {AppDeadlineDate}
                      </span>
                    )}
                  </div>
                  <MediaQuery query="(min-width: 768px)">
                    <div className="job-item__desription">
                      {text}
                      <NavLink
                        className="read-more-button"
                        to={LinkBuilder.getJobLink(ProcessID)}
                      >
                        Read more
                      </NavLink>
                    </div>
                  </MediaQuery>

                  {!showApplyForm && (
                    <MediaQuery query="(min-width: 581px)">
                      <div className="job-item__controls">
                        <BasicButton
                          btnWidth={100}
                          btnHeight={35}
                          btnFontSize="0.8571rem"
                          btnFontWeight={600}
                          btnText={btnText}
                          btnArrow={false}
                          controlFunc={handleClickApply}
                          btnBg="#fff"
                          btnHoverBg="#f40"
                          disabled={isButtonDisabled || applied}
                        />
                        <div className="job-item__statistics">
                          <LinkButton
                            text="View Statistics"
                            btnFontSize="0.9286rem"
                            btnFontWeight="700"
                            btnFontFamily="Noto Sans"
                            controlFunc={handleViewStatistics}
                          />
                        </div>
                        {BlockLinkedInSharing === 'No' && (
                          <div className="job-item__statistics">
                            <LinkButton
                              text="Share on LinkedIn"
                              btnFontSize="0.9286rem"
                              btnFontWeight="700"
                              btnFontFamily="Noto Sans"
                              controlFunc={handleShare}
                            />
                          </div>
                        )}
                      </div>
                    </MediaQuery>
                  )}
                </div>
              </div>
              {showApplyForm && (
                <div className="job-item__apply-form">
                  <ApplyPositionForm
                    onApplyHandler={handleOnApply}
                    onRefuseHandler={hideForm}
                  />
                </div>
              )}

              <MediaQuery query="(max-width: 767px)">
                <div className="job-item__desription">
                  {text}
                  <NavLink
                    className="read-more-button"
                    to={LinkBuilder.getJobLink(ProcessID)}
                  >
                    Read more
                  </NavLink>
                </div>
              </MediaQuery>
            </article>
          </PanelContainer>
        </div>
      )}
    </Spring>
  );
};

export default JobsItem;
